import React from 'react';

import { useArticlePropsById } from '../../hooks/useArticlePropsById';
import styles from './ArticlesItemDetails.module.scss';

interface IArticlesItemDetailsProps {
  articleId: string;
}

const ArticlesItemDetails: React.FC<IArticlesItemDetailsProps> = ({ articleId }) => {
  const { imageUrl } = useArticlePropsById(articleId) ?? {};

  return (
    <div className={styles.container}>
      {imageUrl ? (
        <img alt="article-thumbnail" src={imageUrl} className={styles.img} />
      ) : (
        <div className={styles.noImg} />
      )}
    </div>
  );
};

export default ArticlesItemDetails;
